export enum ModuleName {
  Contracts = 'Contracts',
  DealRooms = 'Dealrooms',
}

export enum ModuleStatus {
  Active = 'Active',
  Inactive = 'Inactive',
}
